/* @flow */
import { v4 } from 'uuid';
// TODO get rid of this unproductive abstraction
export default v4;



// WEBPACK FOOTER //
// ./src/utils/uuid.js